import { useRef } from "react";
import styles from "./ResumePage.module.css";

const RESUME = {
  name: "Avantika Bisht",
  title: "Automation Tech Lead",
  contact: {
    email: "avantikabisht910@gmail.com",
    // phone: "+91-7500015281",
    location: "Gurugram, Haryana 122001",
    linkedin: "linkedin.com/in/avantika-bisht08",
  },
  summary:
    "Automation Tech Lead with 6+ years of experience building enterprise-grade automation platforms and full-stack web solutions. Designed and delivered end-to-end JVM recycle automation across JBOSS, EKS, Econf, Tomcat, and HPP - integrated with ServiceNow incidents and Slack slash commands to enable zero-touch operations. Built React dashboards for real-time monitoring and workflow triggering. Expert in Micro Focus Operation Orchestration, Shell Scripting, and REST APIs. Experienced in defining automation strategy, mentoring teams, and driving measurable reductions in manual operational effort across enterprise environments.",
  skills: [
    {
      category: "Languages",
      items: ["JavaScript (ES6+)", "TypeScript", "PHP", "Python"],
    },
    {
      category: "Frameworks & Libraries",
      items: [
        "ReactJS",
        "React Native",
        "Redux",
        "Context API",
        "React Hooks",
        "jQuery",
        "Bootstrap 4",
        "Yii Framework",
      ],
    },
    {
      category: "Frontend",
      items: ["HTML5", "CSS3", "Responsive Design", "Web Accessibility"],
    },
    {
      category: "Backend",
      items: [
        "PHP",
        "REST API Integration",
        "Third-Party API Integration",
        "Node.js",
      ],
    },
    {
      category: "Automation & IaC",
      items: [
        "Micro Focus Operation Orchestration",
        "Terraform",
        "Shell Scripting",
        "Infrastructure as Code",
      ],
    },
    {
      category: "Version Control & Tools",
      items: [
        "Git",
        "GitHub",
        "Bitbucket",
        "Postman",
        "Harness Pipelines",
        "Jira",
      ],
    },
    {
      category: "Architecture",
      items: [
        "Design & Architecture Patterns",
        "Scalable Application Design",
        "Agile",
        "Scrum",
      ],
    },
  ],
  experience: [
    {
      role: "SW/App/Cloud Tech Support Team Lead",
      company: "Accenture",
      location: "Gurugram, Haryana (Hybrid)",
      period: "Dec 2024 – Present",
      points: [
        "Architected and delivered end-to-end JVM recycle automation across JBOSS, EKS, Econf, Tomcat, and HPP platforms - eliminating manual intervention and reducing system downtime response time significantly.",
        "Built a React-based operations dashboard providing real-time visibility into automation workflows, enabling teams to monitor and trigger JVM recycles and track end-to-end timelines directly from the UI.",
        "Integrated ServiceNow incident management with automation pipelines to auto-trigger JVM recycling upon incident creation - removing manual triage steps and accelerating resolution.",
        "Developed Slack slash command integrations allowing engineers to trigger automation workflows and fill operational forms directly from Slack - reducing context-switching and manual effort.",
        "Defined automation strategies, roadmaps, and KPIs aligned with organizational goals; led cross-functional teams providing mentorship and code reviews.",
        "Oversaw end-to-end project delivery managing resources, timelines, and stakeholder expectations across multiple concurrent automation initiatives.",
      ],
    },
    {
      role: "SW/App/Cloud Tech Support Sr Analyst",
      company: "Accenture",
      location: "Gurugram, Haryana (Hybrid)",
      period: "Dec 2022 – Nov 2024",
      points: [
        "Led early-stage development of JVM recycle automation using Micro Focus Operation Orchestration - laying the foundation for zero-touch incident resolution across JBOSS and Tomcat platforms.",
        "Designed and implemented automation workflows using PHP, JavaScript, and TypeScript, significantly reducing manual effort in operational processes.",
        "Contributed to the ServiceNow integration layer enabling automatic incident-triggered automation execution without manual intervention.",
        "Developed Python-based utilities for data processing and automation task orchestration across internal tooling.",
        "Implemented and managed CI/CD pipelines using Harness to streamline deployment and release processes.",
        "Collaborated with cross-functional teams to translate business requirements into scalable, production-grade automation solutions.",
      ],
    },
    {
      role: "Advance App Engineering Analyst",
      company: "Accenture",
      location: "Gurugram, Haryana",
      period: "Oct 2021 – Nov 2022",
      points: [
        "Contributed to application engineering projects, implementing automation workflows and web solutions.",
        "Supported cross-functional delivery teams in building scalable, maintainable codebases.",
      ],
    },
    {
      role: "Senior Front End Developer",
      company: "Sudofire Technologies",
      location: "Gurugram, India",
      period: "Oct 2020 – Oct 2021",
      points: [
        "Developed and maintained cross-platform mobile applications using React Native for iOS and Android.",
        "Collaborated with product managers and designers to deliver robust, scalable React Native code.",
        "Implemented state management, navigation, and third-party integrations within React Native applications.",
        "Conducted code reviews and mentored junior developers on HTML5, CSS3, JavaScript, and jQuery.",
      ],
    },
    {
      role: "Front End Developer",
      company: "Sudofire Technologies",
      location: "Gurugram, India",
      period: "Jul 2019 – Oct 2020",
      points: [
        "Designed, developed, and deployed 20+ websites across diverse industries using modern web technologies.",
        "Implemented best practices for web security, performance optimization, and cross-browser compatibility.",
        "Stayed current with emerging industry trends, incorporating new tools to enhance website functionality.",
      ],
    },
  ],
  education: [
    {
      degree: "Master of Technology - Computer Science",
      school: "Maharshi Dayanand University",
      location: "Rohtak, India",
      period: "Jun 2022 – Aug 2024",
    },
    {
      degree: "Bachelor of Technology - Computer Science",
      school: "Roorkee College of Engineering",
      location: "Roorkee, India",
      period: "Jun 2015 – Aug 2019",
    },
  ],
  awards: [
    {
      title: "The Transformer Award",
      desc: "Recognized for driving impactful changes and implementing innovative automation solutions.",
    },
    {
      title: "The Extra Mile Award",
      desc: "Acknowledged for exceptional dedication and exceeding expectations in project delivery.",
    },
    {
      title: "Inspiring Innovator Award",
      desc: "Honored for proposing and executing creative solutions that enhanced efficiency and performance.",
    },
  ],
  languages: ["English", "Hindi"],
};

export default function ResumePage() {
  const resumeRef = useRef(null);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className={styles.page}>
      {/* ── Download bar (screen only) ── */}
      <div className={styles.downloadBar}>
        <div className={`container ${styles.downloadInner}`}>
          <div className={styles.downloadLeft}>
            <span className={styles.downloadLabel}>
              📄 Avantika Bisht - Resume
            </span>
            {/* <span className={styles.atsScore}>
              <span className={styles.atsDot} />
              ATS Score: <strong>92/100</strong>
            </span> */}
          </div>
          <button className={styles.downloadBtn} onClick={handlePrint}>
            ↓ Download PDF
          </button>
        </div>
      </div>

      {/* ── Resume document ── */}
      <div className={`container ${styles.wrapper}`}>
        <div className={styles.resume} ref={resumeRef}>
          {/* Header */}
          <header className={styles.header}>
            <div className={styles.headerLeft}>
              <h1 className={styles.name}>{RESUME.name}</h1>
              <p className={styles.titleRole}>{RESUME.title}</p>
              <div className={styles.contactRow}>
                <a
                  href={`mailto:${RESUME.contact.email}`}
                  className={styles.contactLink}
                >
                  ✉ {RESUME.contact.email}
                </a>
                {/* <span className={styles.dot}>·</span> */}
                {/* <span>✆ {RESUME.contact.phone}</span> */}
                {/* <span className={styles.dot}>·</span> */}
                <span>📍 {RESUME.contact.location}</span>
              </div>
              <div className={styles.contactRow}>
                <a
                  href={`https://${RESUME.contact.linkedin}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.contactLink}
                >
                  🔗 {RESUME.contact.linkedin}
                </a>
              </div>
            </div>
            <div className={styles.headerAccent} aria-hidden="true" />
          </header>

          {/* Body: two-column layout */}
          <div className={styles.body}>
            {/* Left sidebar */}
            <aside className={styles.sidebar}>
              {/* Skills */}
              <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Skills</h2>
                <ul className={styles.skillLines}>
                  {RESUME.skills.map((group) => (
                    <li key={group.category} className={styles.skillLine}>
                      <span className={styles.skillLineLabel}>
                        {group.category}:{" "}
                      </span>
                      <span className={styles.skillLineItems}>
                        {group.items.join(", ")}
                      </span>
                    </li>
                  ))}
                </ul>
              </section>

              {/* Education */}
              <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Education</h2>
                {RESUME.education.map((e) => (
                  <div key={e.degree} className={styles.eduItem}>
                    <p className={styles.eduDegree}>{e.degree}</p>
                    <p className={styles.eduSchool}>{e.school}</p>
                    <p className={styles.eduMeta}>
                      {e.location} · {e.period}
                    </p>
                  </div>
                ))}
              </section>

              {/* Awards */}
              <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Awards</h2>
                {RESUME.awards.map((a) => (
                  <div key={a.title} className={styles.awardItem}>
                    <p className={styles.awardTitle}>🏆 {a.title}</p>
                    <p className={styles.awardDesc}>{a.desc}</p>
                  </div>
                ))}
              </section>

              {/* Languages */}
              <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Languages</h2>
                <div className={styles.skillPills}>
                  {RESUME.languages.map((l) => (
                    <span key={l} className={styles.pill}>
                      {l}
                    </span>
                  ))}
                </div>
              </section>
            </aside>

            {/* Main content */}
            <main className={styles.main}>
              {/* Summary */}
              <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Professional Summary</h2>
                <p className={styles.summary}>{RESUME.summary}</p>
              </section>

              {/* Experience */}
              <section className={styles.section}>
                <h2 className={styles.sectionTitle}>Work Experience</h2>
                {RESUME.experience.map((job, i) => (
                  <div key={i} className={styles.jobItem}>
                    <div className={styles.jobHeader}>
                      <div>
                        <h3 className={styles.jobRole}>{job.role}</h3>
                        <p className={styles.jobMeta}>
                          <strong>{job.company}</strong> · {job.location}
                        </p>
                      </div>
                      <span className={styles.jobPeriod}>{job.period}</span>
                    </div>
                    <ul className={styles.jobPoints}>
                      {job.points.map((p, j) => (
                        <li key={j}>{p}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </section>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
